function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M320.82 371.793h39.98v79.957c0 33.066-26.902 59.965-59.968 59.965H59.965C26.902 511.715 0 484.816 0 451.75V59.965C0 26.902 26.902 0 59.965 0h240.867c33.066 0 59.969 26.902 59.969 59.965v79.957h-39.98V59.965c0-11.02-8.966-19.988-19.989-19.988H59.965c-11.02 0-19.988 8.968-19.988 19.988V451.75c0 11.02 8.968 19.988 19.988 19.988h240.867c11.023 0 19.988-8.968 19.988-19.988zm96.95-210.168l-28.27 28.27 45.973 45.976h-258.57v39.977h258.57L389.5 321.82l28.27 28.27L512 255.86zm0 0"
});

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt"
  }, props), _ref);
}

export default SvgLogout;